<template>
  <div class="recipe-grid-container">
    <div class="grid-header">
      <h2 class="section-title">
        {{ title }}
      </h2>
      <span class="results-count">{{ recipes.length }} recept</span>
    </div>

    <!-- Receptnätverk -->
    <div v-if="recipes.length > 0" class="recipe-grid">
      <RecipeCard
        v-for="recipe in recipes"
        :key="recipe.id"
        :recipe="recipe"
        @select-recipe="$emit('select-recipe', $event)"
      />
    </div>

    <!-- Tomt tillstånd -->
    <div v-else class="empty-state">
      <div class="empty-icon">🍳</div>
      <h3>Inga recept hittades</h3>
      <p>Vi hittade inga recept som matchade din sökning eller filter.</p>
      <button class="reset-filter-btn" @click="$emit('reset-filters')" type="button">
        Visa alla recept
      </button>
    </div>
  </div>
</template>

<script>
import RecipeCard from './RecipeCard.vue'

export default {
  name: 'RecipeGrid',
  components: {
    RecipeCard
  },
  props: {
    recipes: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: 'Recept'
    }
  },
  emits: ['select-recipe', 'reset-filters']
}
</script>

<style scoped>
.recipe-grid-container {
  padding: 16px 0 48px 0;
}

.grid-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 16px;
}

.section-title {
  font-size: 1.35rem;
  font-weight: 700;
  color: var(--color-text-main);
}

.results-count {
  font-size: 0.88rem;
  color: var(--color-text-muted);
}

.recipe-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 24px;
}

.empty-state {
  text-align: center;
  padding: 48px 16px;
  background-color: var(--color-card-bg);
  border-radius: var(--radius-md);
  border: 1px dashed var(--color-border);
  margin-top: 8px;
}

.empty-icon {
  font-size: 2.8rem;
  margin-bottom: 12px;
}

.empty-state h3 {
  font-size: 1.2rem;
  margin-bottom: 6px;
  color: var(--color-text-main);
}

.empty-state p {
  color: var(--color-text-muted);
  margin-bottom: 18px;
  font-size: 0.92rem;
}

.reset-filter-btn {
  background-color: var(--color-primary);
  color: #fff;
  padding: 10px 22px;
  border-radius: var(--radius-lg);
  font-weight: 600;
  font-size: 0.95rem;
  touch-action: manipulation;
}

.reset-filter-btn:hover {
  background-color: var(--color-primary-hover);
}

@media (max-width: 640px) {
  .recipe-grid-container {
    padding: 10px 0 36px 0;
  }
  .recipe-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .section-title {
    font-size: 1.2rem;
  }
}
</style>
